import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/accounting/reconciliation',
}).lazy(() => import('./reconciliation.index.lazy').then((d) => d.Route))
